import { attachShareScopeMap } from "./attachShareScopeMap.js";
import { remotes } from "./remotes.js";
import { consumes } from "./consumes.js";
import { initializeSharing } from "./initializeSharing.js";
import { installInitialConsumes } from "./installInitialConsumes.js";
import { initContainerEntry } from "./initContainerEntry.js";
import { init } from "./init.js";
import { getSharedFallbackGetter } from "./getSharedFallbackGetter.js";
import * as runtime from "@module-federation/runtime";

//#region src/index.ts
const USE_REMOTE = typeof FEDERATION_OPTIMIZE_NO_REMOTE === "boolean" ? !FEDERATION_OPTIMIZE_NO_REMOTE : true;
const USE_SHARED = typeof FEDERATION_OPTIMIZE_NO_SHARED === "boolean" ? !FEDERATION_OPTIMIZE_NO_SHARED : true;
const bundlerRuntime = {
	remotes: USE_REMOTE ? remotes : void 0,
	consumes: USE_SHARED ? consumes : void 0,
	I: USE_SHARED ? initializeSharing : void 0,
	S: {},
	installInitialConsumes: USE_SHARED ? installInitialConsumes : void 0,
	initContainerEntry: (typeof FEDERATION_HAS_EXPOSES === "boolean" ? FEDERATION_HAS_EXPOSES : true) ? initContainerEntry : void 0,
	init,
	getSharedFallbackGetter: USE_SHARED ? getSharedFallbackGetter : void 0
};
const federation = {
	runtime,
	instance: void 0,
	initOptions: void 0,
	bundlerRuntime,
	attachShareScopeMap,
	bundlerRuntimeOptions: {}
};
const instance = federation.instance;
const initOptions = federation.initOptions;
const bundlerRuntimeOptions = federation.bundlerRuntimeOptions;

//#endregion
export { attachShareScopeMap, bundlerRuntime, bundlerRuntimeOptions, federation as default, initOptions, instance, runtime };
//# sourceMappingURL=index.js.map